import React from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from '../theme/theme';
import ChatBotPluginWidget from '../../web_chat/frontend/ChatBotPluginWidget';
import { useFrontendConfiguration } from '../components/FrontendConfigurationProvider';
import { ErrorReportingWrapper } from '../components/ErrorReporting';
import globalTranslationManager from '../../translation/frontend/components/translation_manager';
import { TranslationProvider } from '@/translation/frontend/components/TranslationProvider';
import { LanguageProvider } from '@contexts/LanguageContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

function PluginApp({ token, fullscreen }) {
  const config = useFrontendConfiguration();

  if (config?.frontend?.enable_sute_services === false) {
    return null;
  }

  // Set the document title if in fullscreen mode
  if (fullscreen) {
    document.title =
      config.frontend.environment_title || config.frontend.top_bar_title;
  } else {
    window.PROSPERA_WEB_CHAT_INSTALLED = true;
  }

  // Enable or disable automatic frontend translation
  globalTranslationManager.enabled =
    config.frontend.enable_automatic_frontend_translation;

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorReportingWrapper>
        <LanguageProvider>
          <ThemeProvider theme={theme}>
            <TranslationProvider>
              <ChatBotPluginWidget
                clientToken={token}
                fullscreen={fullscreen}
              />
            </TranslationProvider>
          </ThemeProvider>
        </LanguageProvider>
      </ErrorReportingWrapper>
    </QueryClientProvider>
  );
}

export default PluginApp;
